/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ProgramTypeRef,
  ProgramTypeRefOptional,
  ProgramTypeRefMetaI,
  ProgramTypeRefTrackedI,
} from "./program-type-ref";
import { ProgramTypeRefTracked, ProgramTypeRefMeta } from "./program-type-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassInstanceRef,
  UnifiedClassInstanceRefOptional,
  UnifiedClassInstanceRefMetaI,
  UnifiedClassInstanceRefTrackedI,
} from "./unified-class-instance-ref";
import {
  UnifiedClassInstanceRefTracked,
  UnifiedClassInstanceRefMeta,
} from "./unified-class-instance-ref";

/**
 *
 * @export
 * @interface StaffProcessWaitlistOffersRequestDTO
 */
export interface StaffProcessWaitlistOffersRequestDTOOptional {
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof StaffProcessWaitlistOffersRequestDTO
   */
  classInstance?: UnifiedClassInstanceRefOptional;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof StaffProcessWaitlistOffersRequestDTO
   */
  program?: ProgramTypeRefOptional;
}

export interface StaffProcessWaitlistOffersRequestDTO extends StaffProcessWaitlistOffersRequestDTOOptional {
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof StaffProcessWaitlistOffersRequestDTO
   */
  classInstance: UnifiedClassInstanceRef;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof StaffProcessWaitlistOffersRequestDTO
   */
  program: ProgramTypeRef;
}

export interface StaffProcessWaitlistOffersRequestDTOTrackedI {
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof StaffProcessWaitlistOffersRequestDTO
   */
  classInstance?: UnifiedClassInstanceRefTrackedI;
  classInstanceIsSet: boolean;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof StaffProcessWaitlistOffersRequestDTO
   */
  program?: ProgramTypeRefTrackedI;
  programIsSet: boolean;
}

transformDatesMap.set(
  "StaffProcessWaitlistOffersRequestDTO",
  function (model: StaffProcessWaitlistOffersRequestDTO) {
    const transformDatesclassInstance = transformDatesMap.get(
      "UnifiedClassInstanceRef",
    );
    if (transformDatesclassInstance && model.classInstance) {
      transformDatesclassInstance(model.classInstance);
    }
    const transformDatesprogram = transformDatesMap.get("ProgramTypeRef");
    if (transformDatesprogram && model.program) {
      transformDatesprogram(model.program);
    }
  },
);

export type StaffProcessWaitlistOffersRequestDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  classInstance: PropertyMeta<UnifiedClassInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  program: PropertyMeta<ProgramTypeRefMetaI>;
}>;

export var StaffProcessWaitlistOffersRequestDTOMeta: StaffProcessWaitlistOffersRequestDTOMetaI =
  {} as StaffProcessWaitlistOffersRequestDTOMetaI;
StaffProcessWaitlistOffersRequestDTOMeta = typeMeta(
  "StaffProcessWaitlistOffersRequestDTO",
  {
    classInstance: propertyMeta(
      "classInstance",
      false,
      true,
      false,
      UnifiedClassInstanceRefMeta,
    ),
    program: propertyMeta("program", false, true, false, ProgramTypeRefMeta),
  },
);

const metaI = StaffProcessWaitlistOffersRequestDTOMeta;

registerMeta(() => {});

export class StaffProcessWaitlistOffersRequestDTOTracked implements StaffProcessWaitlistOffersRequestDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  classInstance__I?: UnifiedClassInstanceRefTracked = undefined;
  classInstanceIsSet: boolean = false;
  set classInstance(v: undefined | UnifiedClassInstanceRefTracked) {
    if (v !== undefined) {
      this.classInstance__I = v;
      this.classInstanceIsSet = true;
    } else {
      this.classInstance__I = v || undefined;
      this.classInstanceIsSet = true;
    }
    this.changeTracker = true;
  }
  get classInstance() {
    return this.classInstance__I;
  }
  program__I?: ProgramTypeRefTracked = undefined;
  programIsSet: boolean = false;
  set program(v: undefined | ProgramTypeRefTracked) {
    if (v !== undefined) {
      this.program__I = v;
      this.programIsSet = true;
    } else {
      this.program__I = v || undefined;
      this.programIsSet = true;
    }
    this.changeTracker = true;
  }
  get program() {
    return this.program__I;
  }
  constructor(
    config?: StaffProcessWaitlistOffersRequestDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.classInstance?.setIds();

    this.program?.setIds();
  }
  assignFrom(
    config: StaffProcessWaitlistOffersRequestDTOOptional,
    options?: AssignOptions,
  ): StaffProcessWaitlistOffersRequestDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.classInstance &&
      this.classInstanceApplyFilter(optionsRequired.filter)
    ) {
      this.classInstance = new UnifiedClassInstanceRefTracked(
        config.classInstance,
        options,
      );
      if (optionsRequired.unassign) this.classInstanceIsSet = false;
      else this.classInstanceIsSet = true;
    }
    if (config.program && this.programApplyFilter(optionsRequired.filter)) {
      this.program = new ProgramTypeRefTracked(config.program, options);
      if (optionsRequired.unassign) this.programIsSet = false;
      else this.programIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(
    filter?: FilterVarsType,
  ): StaffProcessWaitlistOffersRequestDTOTrackedI {
    const cloned = {} as StaffProcessWaitlistOffersRequestDTOTrackedI;
    if (
      this.classInstanceIsSetDeep() &&
      this.classInstanceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classInstanceIsSet = true;
      cloned.classInstance = this.classInstance?.removeUnset(filter);
    } else {
      //cloned.classInstanceIsSet = false
    }
    if (
      this.programIsSetDeep() &&
      this.programApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.programIsSet = true;
      cloned.program = this.program?.removeUnset(filter);
    } else {
      //cloned.programIsSet = false
    }
    return cloned;
  }
  unassignAll(
    filter?: FilterVarsType,
  ): StaffProcessWaitlistOffersRequestDTOTrackedI {
    if (!this.classInstanceApplyFilter(filter)) this.classInstanceIsSet = false;
    this.classInstance?.unassignAll(filter);

    if (!this.programApplyFilter(filter)) this.programIsSet = false;
    this.program?.unassignAll(filter);

    return this;
  }
  classInstanceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StaffProcessWaitlistOffersRequestDTOMeta.classInstance,
      StaffProcessWaitlistOffersRequestDTOMeta,
      this.classInstance,
      this,
    );
  }
  classInstanceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classInstanceIsSet && this.classInstanceApplyFilter(filter))
      return true;
    return this.classInstance?.anySet(filter) == true;

    return false;
  }
  programApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StaffProcessWaitlistOffersRequestDTOMeta.program,
      StaffProcessWaitlistOffersRequestDTOMeta,
      this.program,
      this,
    );
  }
  programIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.programIsSet && this.programApplyFilter(filter)) return true;
    return this.program?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.classInstanceIsSetDeep(filter)) return true;
    if (this.programIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
